
      import { domainCountryMap } from './src/config/domainMap.js';
      (function () {
        const viteAdobeUrl = {
          CO: 'https://assets.adobedtm.com/47e3e446470b/b0fedc97d9ea/launch-767b29958c9a.min.js',
          NI: 'https://assets.adobedtm.com/47e3e446470b/3994d1a682b5/launch-ee776c962a8d.min.js',
          HN: 'https://assets.adobedtm.com/47e3e446470b/44c2180c1c13/launch-8775c914a702.min.js',
        };

        const viteTrustArcUrl = {
          CO: '//consent.trustarc.com/notice?domain=cargill_pollosbucanero.com&c=teconsent&js=nj&noticeType=bb&gtm=1&text=true&irmc=trustarc-irm-placeholder&language=es',
          NI: '//consent.trustarc.com/notice?domain=cargill_fresqra.tanbuenoquesenota.com&c=teconsent&js=nj&noticeType=bb&gtm=1&text=true&irmc=trustarc-irm-placeholder&language=es',
          HN: '//consent.trustarc.com/notice?domain=cargill_fresqra.hn.tanbuenoquesenota.com&c=teconsent&js=nj&noticeType=bb&gtm=1&text=true&irmc=trustarc-irm-placeholder&language=es',
        };

        const domain = window.location.hostname;
        const country = domainCountryMap[domain] || null;

        if (country) {
          // adobe
          const scriptUrl1 = viteAdobeUrl[country];
          const s1 = document.createElement('script');
          s1.src = scriptUrl1;
          s1.async = true;
          document.head.appendChild(s1);
          // trustArc
          const scriptUrl2 = viteTrustArcUrl[country];
          const s2 = document.createElement('script');
          s2.src = scriptUrl2;
          s2.crossOrigin = '';
          document.head.appendChild(s2);
        }
      })();
    